import { render, staticRenderFns } from "./Investments.vue?vue&type=template&id=2533dddc&scoped=true&"
import script from "./Investments.vue?vue&type=script&lang=js&"
export * from "./Investments.vue?vue&type=script&lang=js&"
import style0 from "./Investments.vue?vue&type=style&index=0&id=2533dddc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2533dddc",
  null
  
)

export default component.exports